export const morphologyConst = {
  path: "/single-programs/morphology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – МОРФОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра, магистра, специалитет
      </p>
      <p>
        <strong>Форма обучения:</strong> очная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Морфология — фундаментальная наука о строении человека</h2>
      <p>
        Морфология — это база всей медицины. Это направление охватывает анатомию, гистологию, цитологию и эмбриологию — науки, без которых
        невозможно понять, как функционирует организм. Специальность подходит тем, кто хочет глубоко изучать строение человека, заниматься
        научными исследованиями, преподаванием или подготовкой будущих врачей.
      </p>
      <p>
        Образование в области морфологии требует внимания к деталям, аналитического мышления и интереса к биомедицинской науке. Программа
        ориентирована на сочетание теоретических знаний и работы в лабораториях — с микроскопом, препаратами, моделями и цифровыми
        технологиями.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Топографическая и системная анатомия человека</li>
        <li>Гистология — микроструктура тканей и органов</li>
        <li>Цитология — строение и функции клеток</li>
        <li>Эмбриология — развитие организма от зачатия</li>
        <li>Современные методы морфологического анализа</li>
        <li>Электронная микроскопия и цифровая морфология</li>
        <li>Биомедицинская визуализация и 3D-моделирование</li>
        <li>Основы научных исследований и академического письма</li>
      </ul>
      <p>
        Программа включает обязательную лабораторную практику, анатомические вскрытия, моделирование и участие в междисциплинарных проектах.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Анатом — в университетах и медицинских вузах</li>
        <li>Гистолог — в лабораториях, биомедицинских центрах</li>
        <li>Преподаватель анатомии, гистологии и морфологии</li>
        <li>Медицинский иллюстратор или визуализатор</li>
        <li>Научный сотрудник в области морфогенеза и клеточной биологии</li>
        <li>Специалист в области биотехнологий и регенеративной медицины</li>
      </ul>
      <h2>Средний доход специалистов в Европе:</h2>
      <p>
        от <strong>€40,000 до €80,000 в год,</strong> в зависимости от специализации и сферы (академическая, клиническая, исследовательская)
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Глубокая академическая подготовка с первого курса</li>
        <li>Прямой путь в науку и преподавание</li>
        <li>Работа в современных лабораториях с цифровыми и 3D-технологиями</li>
        <li>Возможность участия в международных конференциях и публикациях</li>
        <li>Сильное научное сообщество и наставничество</li>
        <li>Поддержка при поступлении в аспирантуру или стажировку за границей</li>
      </ul>
      <p>
        <strong>
          Морфология — это наука, с которой начинается медицина. Именно здесь рождаются фундаментальные знания, формируются будущие
          профессора и исследователи.
        </strong>
      </p>
      <h2>Как поступить?</h2>
      <p>
        Поступить на программу легко — приёмная комиссия поможет с оформлением всех документов. Мы сопровождаем вас от заявки до первого дня
        учёбы.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра, магистра, специалитет
    Формы обучения: очная
    Форма связи: Получить консультацию приемной комиссии
    Морфология — фундаментальная наука о строении человека
    Морфология — это база всей медицины. Это направление охватывает анатомию, гистологию, цитологию и эмбриологию — науки, без которых невозможно понять, как функционирует организм. Специальность подходит тем, кто хочет глубоко изучать строение человека, заниматься научными исследованиями, преподаванием или подготовкой будущих врачей.
    Образование в области морфологии требует внимания к деталям, аналитического мышления и интереса к биомедицинской науке. Программа ориентирована на сочетание теоретических знаний и работы в лабораториях — с микроскопом, препаратами, моделями и цифровыми технологиями.

    Что вы будете изучать?
    • Топографическая и системная анатомия человека
    • Гистология — микроструктура тканей и органов
    • Цитология — строение и функции клеток
    • Эмбриология — развитие организма от зачатия
    • Современные методы морфологического анализа
    • Электронная микроскопия и цифровая морфология
    • Биомедицинская визуализация и 3D-моделирование
    • Основы научных исследований и академического письма
    Программа включает обязательную лабораторную практику, анатомические вскрытия, моделирование и участие в междисциплинарных проектах.

    Кем можно работать после окончания?
    • Анатом — в университетах и медицинских вузах
    • Гистолог — в лабораториях, биомедицинских центрах
    • Преподаватель анатомии, гистологии и морфологии
    • Медицинский иллюстратор или визуализатор
    • Научный сотрудник в области морфогенеза и клеточной биологии
    • Специалист в области биотехнологий и регенеративной медицины

    Средний доход специалистов в Европе:
    от €40,000 до €80,000 в год, в зависимости от специализации и сферы (академическая, клиническая, исследовательская)

    Почему выбирают нас?
    • Глубокая академическая подготовка с первого курса
    • Прямой путь в науку и преподавание
    • Работа в современных лабораториях с цифровыми и 3D-технологиями
    • Возможность участия в международных конференциях и публикациях
    • Сильное научное сообщество и наставничество
    • Поддержка при поступлении в аспирантуру или стажировку за границей

    Морфология — это наука, с которой начинается медицина. Именно здесь рождаются фундаментальные знания, формируются будущие профессора и исследователи.

    Как поступить?
    Поступить на программу легко — приёмная комиссия поможет с оформлением всех документов. Мы сопровождаем вас от заявки до первого дня учёбы.
  `,
};
